import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import moment from 'moment';
import { styleSheet } from './styles';

const getStatusStyle = (status?: Api.RelationshipHealthStatus) => {
	if (status === 'Healthy') {
		return styleSheet.lastInteractionTextHealthy;
	}

	if (status === 'Unhealthy') {
		return styleSheet.lastInteractionTextUnhealthy;
	}

	return styleSheet.lastInteractionTextNeutral;
};

const getLastInteractionInDays = (lastInteractionDate?: string) => {
	if (!lastInteractionDate) {
		return null;
	}

	const days = moment().diff(moment(lastInteractionDate), 'day');
	return days >= 0 ? days : null;
};

const getLabel = (lastInteractionInDays: number | null) => {
	if (lastInteractionInDays === null) {
		return 'No recorded interactions';
	}

	return lastInteractionInDays > 0
		? `Last Interaction - ${lastInteractionInDays} day${lastInteractionInDays > 1 ? 's' : ''} ago`
		: 'Last Interaction within a day';
};

export const LastInteractionInfo = ({ relationshipHealth }: { relationshipHealth?: Api.IRelationshipHealth }) => {
	const lastInteractionInDays = getLastInteractionInDays(relationshipHealth?.lastInteractionDate);
	if (lastInteractionInDays === null && !relationshipHealth?.status) {
		return null;
	}

	return (
		<div className={css(styleSheet.lastInteractionText, getStatusStyle(relationshipHealth?.status))}>
			<div className='indicator' />
			{getLabel(lastInteractionInDays)}
		</div>
	);
};
